import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  news: []
};

const newsFeederSlicer = createSlice({
  name: 'newsFeeder',
  initialState,
  reducers: {
    setNews: (state, action) => {
      state.news = action.payload;
    }
  }
});

export const { setNews } = newsFeederSlicer.actions;
export default newsFeederSlicer.reducer;

